/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".profileIcon[_ngcontent-%COMP%]{position:absolute;top:10px;right:20px}\n/*# sourceMappingURL=splash.component.css.map*/"];
export { styles as styles };
